/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import {
  fectchHelpers,
} from '../actions/general.action';

const initialState = {
  open: false,
  productTypes: [],
  organizationTypes: [],
  committeeRoles: [],
  loanTypes: [],
  employeeRoles: [],
  userStatuses: [],
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    openDrawer: (state) => {
      state.open = true;
    },
    closeDrawer: (state) => {
      state.open = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fectchHelpers.fulfilled, (state, action) => {
        const {
          productTypes, roles, organizationTypes, committeeRoles, loanTypes, employeeRoles, userStatuses,
        } = action.payload;
        state.committeeRoles = committeeRoles;
        state.roles = roles;
        state.employeeRoles = employeeRoles;
        state.organizationTypes = organizationTypes;
        state.productTypes = productTypes;
        state.userStatuses = userStatuses;
        state.loanTypes = loanTypes;
      })

      .addCase(fectchHelpers.pending, (state, action) => {

      })
      .addCase(fectchHelpers.rejected, (state, action) => {

      });
  },
});

export const { openDrawer, closeDrawer } = appSlice.actions;

export const isDrawerOpen = (state) => state.app.open;

export default appSlice.reducer;
